module.exports = __webpack_public_path__ + "static/media/react.970c16a3.png";